import { render, staticRenderFns } from "./TabLinks.vue?vue&type=template&id=3d8b6054&"
import script from "./TabLinks.vue?vue&type=script&lang=ts&"
export * from "./TabLinks.vue?vue&type=script&lang=ts&"
import style0 from "./TabLinks.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports